function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.75781 16.3711L3.77625 15.3235L11.4119 22.7468L10.3934 23.7944L2.75781 16.3711Z",
  fill: "#0A1F39"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.572754 25.0081L1.60931 23.9783L5.70831 28.1041L4.67175 29.1339L0.572754 25.0081Z",
  fill: "#0A1F39"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.65284 25.8122L5.60859 24.7901L8.06237 22.283L9.10663 23.305L6.65284 25.8122Z",
  fill: "#0A1F39"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.30824 25.3421L1.27847 24.3055L5.69123 19.9219L6.721 20.9585L2.30824 25.3421Z",
  fill: "#0A1F39"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5798 24.8397C7.85157 25.0546 8.29306 25.5085 8.45813 25.8132C8.62321 26.1178 8.72466 26.4528 8.75632 26.7978C8.78798 27.1428 8.7492 27.4907 8.64232 27.8202C8.53545 28.1498 8.36271 28.4542 8.1346 28.715C7.90648 28.9758 7.62775 29.1875 7.31533 29.3372C7.0029 29.487 6.6633 29.5717 6.31713 29.5863C5.97097 29.6008 5.62546 29.5448 5.30159 29.4217C4.97772 29.2986 4.68225 29.111 4.4331 28.8702L5.41936 27.8496C5.53022 27.9568 5.66169 28.0402 5.8058 28.095C5.9499 28.1498 6.10363 28.1747 6.25766 28.1682C6.41168 28.1618 6.56279 28.1241 6.7018 28.0574C6.84082 27.9908 6.96484 27.8966 7.06634 27.7806C7.16784 27.6645 7.24469 27.5291 7.29225 27.3824C7.3398 27.2358 7.35706 27.081 7.34297 26.9275C7.32888 26.774 7.28374 26.6249 7.21029 26.4894C7.13684 26.3538 6.77323 25.9088 6.65231 25.8132L7.5798 24.8397Z",
  fill: "#0A1F39"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3139 28.8678L14.2966 27.8189L18.4714 23.7698L19.4887 24.8187L15.3139 28.8678Z",
  fill: "#0A1F39"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16.191 22.7978L15.1565 23.8297L12.4198 20.9927L13.4243 19.9994L16.191 22.7978Z",
  fill: "#0A1F39"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6687 27.1365L14.6198 28.1537L10.2896 23.6885L11.3385 22.6713L15.6687 27.1365Z",
  fill: "#0A1F39"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2298 21.8592C15.4479 21.5901 15.9071 21.1541 16.2137 20.9927C16.5203 20.8313 16.8565 20.7339 17.2018 20.7063C17.5472 20.6788 17.8946 20.7218 18.2228 20.8326C18.5511 20.9435 18.8534 21.1198 19.1114 21.3511C19.3695 21.5823 19.5778 21.8636 19.7238 22.1778C19.8698 22.492 19.9504 22.8326 19.9608 23.1789C19.9711 23.5252 19.911 23.87 19.784 24.1924C19.6571 24.5147 19.4659 24.8079 19.2222 25.0542L18.2135 24.0557C18.3219 23.9461 18.407 23.8157 18.4635 23.6723C18.52 23.5288 18.5467 23.3754 18.5421 23.2213C18.5375 23.0672 18.5016 22.9157 18.4367 22.7759C18.3717 22.6361 18.279 22.5109 18.1642 22.408C18.0494 22.3051 17.9149 22.2267 17.7688 22.1773C17.6228 22.128 17.4682 22.1089 17.3145 22.1212C17.1609 22.1334 17.0113 22.1767 16.8749 22.2486C16.7385 22.3204 16.2891 22.6786 16.192 22.7984L15.2298 21.8592Z",
  fill: "#0A1F39"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2133 16.3692C17.544 15.0258 18.4493 13.3136 18.8145 11.4498C19.1797 9.58609 18.9883 7.6548 18.2646 5.90105C17.5409 4.1473 16.3175 2.65013 14.7496 1.59952C13.1817 0.548912 11.34 -0.00778038 9.45825 8.21121e-05C7.57648 0.0079446 5.73943 0.580007 4.18022 1.64368C2.621 2.70736 1.40989 4.2147 0.700565 5.97444C-0.00875698 7.73418 -0.184319 9.66699 0.196156 11.5276C0.576631 13.3883 1.49599 15.0929 2.83758 16.4251L3.84457 15.3915C2.70583 14.2607 1.92547 12.8138 1.60253 11.2345C1.27958 9.65518 1.4286 8.01461 2.03067 6.52094C2.63274 5.02727 3.66073 3.74784 4.9842 2.845C6.30766 1.94215 7.86695 1.45658 9.46419 1.44991C11.0614 1.44323 12.6247 1.91575 13.9555 2.80751C15.2863 3.69927 16.3247 4.97006 16.939 6.45865C17.5533 7.94723 17.7158 9.58651 17.4058 11.1685C17.0958 12.7504 16.3273 14.2038 15.1979 15.344L16.2133 16.3692Z",
  fill: "#0A1F39"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 15.2144,
  y: 15.3164,
  width: 1.44253,
  height: 7.54719,
  transform: "rotate(45 15.2144 15.3164)",
  fill: "#0A1F39"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7852 9.58887C12.7852 11.3541 11.3541 12.7852 9.58887 12.7852C7.82361 12.7852 6.39258 11.3541 6.39258 9.58887C6.39258 7.82361 7.82361 6.39258 9.58887 6.39258C11.3541 6.39258 12.7852 7.82361 12.7852 9.58887ZM7.74359 9.58887C7.74359 10.608 8.56975 11.4342 9.58887 11.4342C10.608 11.4342 11.4342 10.608 11.4342 9.58887C11.4342 8.56975 10.608 7.74359 9.58887 7.74359C8.56975 7.74359 7.74359 8.56975 7.74359 9.58887Z",
  fill: "#0A1F39"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16c264b4.svg";
export { ForwardRef as ReactComponent };